import React from 'react'
import {connect} from 'react-redux'
// import {Link} from 'react-router-dom'
import {Menu, Dropdown, Avatar} from 'antd'
import {UserOutlined} from '@ant-design/icons';
import {getRaw} from 'services/crud'
import styles from './style.module.scss'
class ProfileMenu extends React.Component {

  state = {
    avatarImage: null,
  };

  componentDidMount() {
    const {user} = this.props;
    this.getAvatar(user.photo);
  }

  logout = () => {
    const {dispatch} = this.props
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  getAvatar = async (code) => {
    const url = '/api/file/open/' + code;
    const avatar = await getRaw(url);
    this.setState({
      avatarImage: avatar
    });
  };

  render() {
    const {user} = this.props;
    const {avatarImage} = this.state;

    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <strong>{user.lastName}{' '}{user.firstName}{' '}{user.middleName}</strong>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <div>
            <strong>Email: </strong>
            {user.email}
            <br />
            <strong>Телефон: </strong>
            {user.phone || '-'}
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <a href="!#" onClick={this.logout}>
            <i className={`${styles.menuIcon} icmn-exit`} />
            Выход
          </a>
        </Menu.Item>
      </Menu>
    )

    const A = (avatarImage) ? (
      <Avatar className={styles.avatar} shape="square" size="large" src={avatarImage} />
    ) : (
      <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />
    );

    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <div className={styles.dropdown}>
          { A }
        </div>
      </Dropdown>
    )
  }
}

export default connect(
  ({user}) => ({user})
)(ProfileMenu)
